import styles from '../mini-dialog.module.css';

export function ToggleTextButton({
  hideText,
  hideTextTitle,
  showTextTitle,
  onClick,
}: {
  hideText: boolean;
  hideTextTitle: string;
  showTextTitle: string;
  onClick: () => void;
}): JSX.Element {
  return (
    <button
      type="button"
      title={hideText ? showTextTitle : hideTextTitle}
      className={styles.optionText}
      onClick={onClick}
    >
      <i className={`bc-icon bc-icon-capital-t${hideText ? '-strike-through' : ''}`} role="img" />
    </button>
  );
}
